<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="3">
					<!--협력사-->
					<clam-repay-search-input
						:label="getMessage_('QWCC000958')"
						paramKey="dlrCpnyCd"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>

				<el-col :span="3">
					<!--품번-->
					<clam-repay-search-input
						:label="getMessage_('QWCC000956')"
						paramKey="causPartNo"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>

				<el-col :span="3">
					<!--RO번호-->
					<clam-repay-search-input :label="getMessage_('QWCC000976')" paramKey="roNo" />
				</el-col>

				<!--ctype-->
				<el-col :span="3">
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001056') }}</span>
						<div class="search-option-wrapper__normal">
							<el-select :value="searchParams.ctype" @change="val => changeSelect(val, 'ctype')">
								<el-option :label="getMessage_('SWCC000753')" value=""></el-option>
								<el-option v-for="option in ctypeList" :key="option.commCd" :label="option.commCdName" :value="option.commCd"> </el-option>
							</el-select>
						</div>
					</div>
				</el-col>

				<!--처리단계-->
				<!-- <el-col :span="3">
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC000963') }}</span>
						<div class="search-option-wrapper__normal">
							<el-select :value="searchParams.prcStepGb" @change="val => changeSelect(val, 'prcStepGb')">
								<el-option :label="getMessage_('SWCC000753')" value=""></el-option>
								<el-option v-for="option in prcsStepList" :key="option.commCd" :label="option.commCdName" :value="option.commCd">
								</el-option>
							</el-select>
						</div>
					</div>
				</el-col> -->

				<!--처리결과-->
				<!-- <el-col :span="3">
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC000978') }}</span>
						<div class="search-option-wrapper__normal">
							<el-select :value="searchParams.prcRsltCd" @change="val => changeSelect(val, 'prcRsltCd')">
								<el-option :label="getMessage_('SWCC000753')" value=""></el-option>
								<el-option v-for="option in prcsRsltList" :key="option.commCd" :label="option.commCdName" :value="option.commCd">
								</el-option>
							</el-select>
						</div>
					</div>
				</el-col> -->

				<el-col :span="4">
					<!--날짜구분-->
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001393') }}</span>
						<div class="search-option-wrapper__normal">
							<el-select :value="searchParams.prcClmDd" @change="val => changeSelect(val, 'prcClmDd')">
								<el-option :label="getMessage_('SWCC000753')" value=""></el-option>
								<el-option v-for="option in clmDdList" :key="option.commCd" :label="option.commCdName" :value="option.commCd"> </el-option>
							</el-select>
						</div>
					</div>
				</el-col>

				<!--검색날짜-->
				<el-col :span="5">
					<sf-group-wrapper :label="getMessage_('QWCC001394')">
						<el-date-picker
							v-model="searchDcsnDdDt"
							@change="changeSearchDcsnDdDt"
							type="daterange"
							align="right"
							start-placeholder="Start Date"
							end-placeholder="End Date"
							range-separator="~"
							format="yyyy-MM-dd"
							style="height: 38px"
						/>
					</sf-group-wrapper>
				</el-col>
			</el-row>

			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/qlty/ClamRepay/store/helpers';
import ClamRepaySearchInput from './ClamRepaySearchInput.vue';

export default {
	props: {
		scrId: { type: String, default: '' },
		pStartDt: { type: String, default: '' }, //클레임 승인현황에서 시작일자 가져옴
		pEndDt: { type: String, default: '' }, //클레임 승인현황에서 종료일자 가져옴
		pState1: { type: String, default: '' }, //클레임 승인현황에서 처리단계 가져옴
		pState2: { type: String, default: '' }, //클레임 승인현황에서 처리결과 가져옴
		pState3: { type: String, default: '' } //클레임 승인현황에서 날짜 검색조건 가져옴
	},

	data() {
		return {
			searchDcsnDdDt: ['', '']
		};
	},
	components: { ClamRepaySearchInput },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		changeSelect(val, key) {
			this.setSearchParam_({ key, value: val });
		},
		setSearchParam({ key, value }) {
			this.setSearchParam_({ key, value });
		},
		searchList() {
			this.$sf_toggleLoading(true);
			this.getClamRepayList_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		changeSearchDcsnDdDt(data) {
			let from;
			let to;

			if (data) {
				from = this.$moment(data[0]).format('YYYY-MM-DD');
				to = this.$moment(data[1]).format('YYYY-MM-DD');
			} else {
				from = '';
				to = '';
			}

			this.searchDcsnDdDt = [from, to];
			this.setSearchParam_({ key: 'startDcsnDd', value: from });
			this.setSearchParam_({ key: 'endDcsnDd', value: to });
		}
	},
	async created() {
		this.$sf_toggleLoading(true);
		await this.postSearchSelectList_();
		//await this.getCommCodes_({ key: 'prcsStepList', codeType: 'PRCS_STEP_01' });
		//await this.getCommCodes_({ key: 'prcsRsltList', codeType: 'PRCS_RSLT_01' });
		//await this.getCommCodes_({ key: 'clmDdList', codeType: 'PWA_DD' });
		//await this.getCommCodes_({ key: 'ctypeList', codeType: 'CTYPE' });

		let pStartDt = this.pStartDt || '';
		let pEndDt = this.pEndDt || '';
		let pState1 = this.pState1 || ''; // 처리단계
		let pState2 = this.pState2 || ''; // 처리결과
		let pState3 = this.pState3 || ''; // 날짜 검색조건

		pStartDt = pStartDt != '' ? this.$moment(pStartDt).format('YYYY-MM-DD') : '';
		pEndDt = pEndDt != '' ? this.$moment(pEndDt).format('YYYY-MM-DD') : '';

		//해당부분 초기화
		this.setSearchParam_({ key: 'prcRsltCd', value: '' });
		this.setSearchParam_({ key: 'prcStepGb', value: '' });
		this.setSearchParam_({ key: 'prcClmDd', value: '' });
		if (!pStartDt && !pEndDt) {
			this.searchDcsnDdDt = [this.getStartInitDd_, this.getEndInitDd_];
			this.setSearchParam_({ key: 'startDcsnDd', value: this.getStartInitDd_ });
			this.setSearchParam_({ key: 'endDcsnDd', value: this.getEndInitDd_ });
		} else {
			this.searchDcsnDdDt = [pStartDt, pEndDt];
			this.setSearchParam_({ key: 'prcRsltCd', value: pState1 });
			this.setSearchParam_({ key: 'prcStepGb', value: pState2 });
			this.setSearchParam_({ key: 'prcClmDd', value: pState3 });
			this.setSearchParam_({ key: 'startDcsnDd', value: pStartDt });
			this.setSearchParam_({ key: 'endDcsnDd', value: pEndDt });
		}

		await this.searchList();
		this.$sf_toggleLoading(false);
	}
};
</script>

<style></style>
